import { WidgetDefinition } from '../models/WidgetDefinition';

export const ScatterWidgetDefinition: WidgetDefinition = {
    baseType: 'scatter',
    group: 'Charts',
    hasImage: true,
    highlights: ['Relationship between sets of values', 'You can show multiple series, aggregate values and define static or dynamic shapes'],
    icon: 'fa-cloud',
    sortingOrder: 200,
    title: 'Scatter plot',
    type: 'scatter'
};